<template>
  <div class="home">
    <loading v-if="loading" />
    <div border="1" v-if="isAuthenticated && isProfileLoaded">
      <email-feed v-for="(fd, index) in feed" :key="index" :feed="fd" />
    </div>
    <div v-if="!isAuthenticated && authStatus !== 'loading'">
      <h1>Welcome to Email !</h1>
      <p>
        This website is a personal project.
      </p>
    </div>
  </div>
</template>

<style>
.home {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 600px;
  margin-top: 20px;
}
</style>

<script>
import EmailFeed from "./feedItem.vue";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    EmailFeed
  },
  name: "home",
  computed: {
    ...mapGetters(["isAuthenticated", "profileStatus", 'getProfile', 'isProfileLoaded']),
    ...mapState({
      feed: state => state.user.profile
    }),
    loading: function() {
      return this.profileStatus === "loading" && !this.isProfileLoaded;
    },
  },
};
</script>
